// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__8hX8z","title":"AfterBackImages_title__1Gyp6","images":"AfterBackImages_images__1eSLi"};